import React from 'react';

import {NoResultsRow} from 'src/components/no-results-row/no-results-row';
import {COLUMN_CAPTIONS, ColumnTypes} from 'src/modules/admin/ai-assist-usage/constants';
import {DetailedMessage} from 'src/modules/admin/ai-assist-usage/views/detailed-message';
import {AiReviewUsageDetailedInfo} from 'src/openapi/models/AiReviewUsageDetailedInfo';

import {Group, Item} from '@pb/kit-component-group';
import {Loading, Types} from '@pb/kit-component-loading';
import Table, {Body, Cell, Head, Row} from '@pb/kit-component-table';
import {formatDate} from '@pb/kit-formatters';

type Props = {
    aiReviewUsageDetailedInfo: AiReviewUsageDetailedInfo[],
    isLoading: boolean,
};

const NO_RESULTS_MESSAGE = 'No results found';
const FIRST_ROW = 1;

export const RunsTable = ({aiReviewUsageDetailedInfo, isLoading}: Props) => {
    return (
        <Group direction="v" className="pdx-xxl" gap="xs">
            <Item><strong>Runs</strong></Item>
            {isLoading ? <Loading fast={true} type={Types.ICON}/> : (
                <Table>
                    <Head>
                        <Cell/>
                        <Cell>{COLUMN_CAPTIONS[ColumnTypes.PROMPT]}</Cell>
                        <Cell>{COLUMN_CAPTIONS[ColumnTypes.RESPONSE]}</Cell>
                        <Cell>{COLUMN_CAPTIONS[ColumnTypes.TYPE]}</Cell>
                        <Cell>{COLUMN_CAPTIONS[ColumnTypes.DATE]}</Cell>
                    </Head>
                    <Body>
                        {aiReviewUsageDetailedInfo.length ? (
                            aiReviewUsageDetailedInfo.map((row, index) => (
                                <Row key={index} showCustomZebra={false}>
                                    <Cell>{FIRST_ROW + index}</Cell>
                                    <Cell verticalAlign="middle">
                                        <DetailedMessage caption="Prompt" text={row.prompt}/>
                                    </Cell>
                                    <Cell verticalAlign="middle">
                                        <DetailedMessage caption="Response" text={row.response}/>
                                    </Cell>
                                    <Cell verticalAlign="middle">{row.runType}</Cell>
                                    <Cell verticalAlign="middle">{formatDate(row.runDate)}</Cell>
                                </Row>
                            ))
                        ) : <NoResultsRow colSpan={7} message={NO_RESULTS_MESSAGE}/>}
                    </Body>
                </Table>
            )}
        </Group>
    );
};
